import axios from 'axios'
import { readAuthToken, authContextKey } from '../lib/authSession'

// Empty baseURL → same-origin requests, routed by Vite proxy in dev
const API_URL = import.meta.env.VITE_API_URL ?? ''
const isSignupRequest = (url = '') => /^\/(?:api\/)?auth\/signup(?:\/(?:confirm|resend))?(?:$|\?)/.test(url)

export const apiClient = axios.create({
  baseURL: API_URL,
  withCredentials: true,
})

// Add request interceptor to attach token
apiClient.interceptors.request.use((config) => {
  if ((config.url?.startsWith('/api/me/') || config.url?.startsWith('/api/public/') || config.url?.startsWith('/api/auth/')) && config.baseURL) config.baseURL = new URL(config.baseURL, window.location.origin).origin
  if (isSignupRequest(config.url)) {
    config.headers.delete('Authorization')
    return config
  }
  const token = readAuthToken()
  ;(config as any)._sessionContext = authContextKey()
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})
apiClient.interceptors.response.use(response => {
  if (!isSignupRequest(response.config.url) && (response.config as any)._sessionContext !== authContextKey()) throw new axios.CanceledError('Organization changed')
  return response
}, error => {
  if (error.config && !isSignupRequest(error.config.url) && error.config._sessionContext !== authContextKey()) return Promise.reject(new axios.CanceledError('Organization changed'))
  const code = error.response?.data?.code
  if (error.response?.data?.message) error.message = error.response.data.message
  if (['SUBSCRIPTION_INACTIVE', 'SUBSCRIPTION_EXPIRED'].includes(code) && !error.config?.url?.startsWith('/api/me/')) {
    window.dispatchEvent(new Event('saas-subscription-changed'))
  }
  return Promise.reject(error)
})
